<!-- Marchio e scritta, a ogni larghezza: la lockup sta anche su un telefono da
     320px, quindi non c'è niente da nascondere. -->
<span
  class="inline-flex items-center gap-[0.5em] select-none"
  aria-hidden="true"
>
  <ui-logo class="text-[1.35em]" />

  <span class="inline-flex items-center leading-none">
    <span class="font-extrabold tracking-tight text-content-fg">Turn</span>
    <span
      class="ml-[0.2em] bg-linear-to-br from-primary to-primary-active bg-clip-text font-extrabold tracking-tight text-transparent"
      >Up</span
    >
    <svg
      class="-translate-y-[0.05em] ml-[0.2em] h-[0.52em] w-[0.52em] shrink-0 text-green-500"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      stroke-width="3.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    >
      <path d="M6 18 18 6" />
      <path d="M9 6h9v9" />
    </svg>
  </span>
</span>
